import { apiGet, apiPost, apiPut } from './apiClient.js';

export function login(email, password) {
  return apiPost('/api/auth/login', { email, password });
}

// Kein register() mehr: die öffentliche Registrierung greift nur noch beim
// Erstlauf einer frischen Installation (scripts/bootstrap.js). Benutzer legt
// sonst ausschliesslich die Benutzerverwaltung an.

export function refresh(refreshToken) {
  return apiPost('/api/auth/refresh', { refreshToken });
}

export function logout(refreshToken) {
  return apiPost('/api/auth/logout', { refreshToken });
}

export function getPreferences() {
  return apiGet('/api/auth/preferences').then((r) => r.items?.preferences || {});
}

export function updatePreferences(preferences) {
  return apiPut('/api/auth/preferences', { preferences }).then((r) => r.preferences || r.data?.preferences);
}

export function getProfile() {
  return apiGet('/api/auth/profile').then((r) => r.items?.profile || {});
}

export function updateProfile(profile) {
  return apiPut('/api/auth/profile', { profile }).then((r) => r.profile || r.data?.profile);
}
